import axios from 'axios';
const createClient = (baseURL, additionalHeaders) => axios.create({
    baseURL,
    timeout: 3000,
    headers: Object.assign({ 'Content-Type': 'application/json' }, additionalHeaders),
});
export default createClient;
//# sourceMappingURL=interceptors.js.map